var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52,4C26.6,4,6,24.6,6,50s20.6,46,46,46c19.8,0,31.9-9.1,38.2-20.4s7.1-24.6,5.2-33.7l-0.4-1.6h-1.6L52,40.2h-2v20.8h22.9 c-3.5,8-10.5,13.5-20.9,13.5c-13.6,0-24.6-11-24.6-24.6s11-24.6,24.6-24.6c6.1,0,11.6,2.3,15.9,5.9l1.4,1.2l13.7-13.7l1.4-1.5 L83,16C74.8,8.6,63.9,4,52,4z M52,8c10.1,0,19.3,3.7,26.6,9.7l-9.6,9.6c-4.8-3.6-10.5-5.9-16.9-5.9c-15.7,0-28.6,12.8-28.6,28.6 S36.3,78.6,52,78.6c13.1,0,22.5-8,25.9-18.9l0.8-2.6H54V44.2l37.7,0.1c1.3,8.1,0.4,19.7-4.9,29.3C81,83.9,70.6,92,52,92 c-23.2,0-42-18.8-42-42S28.8,8,52,8z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.b39f4ad0.svg";
export { ForwardRef as ReactComponent };